import type { GraphNode } from '../graph/nodeDefs.js';
import type { EditorCommands } from './commands.js';

export interface GraphMutations {
  createNodeWithHistory(type: string, x: number, y: number): GraphNode | null;
  deleteNodeWithHistory(id: string): void;
  renameValueNode(nodeId: string, name: string): void;
}

export function createGraphMutations(commands: Pick<EditorCommands, 'addNode' | 'deleteNode' | 'setValueName'>): GraphMutations {
  return {
    createNodeWithHistory(type, x, y) {
      return commands.addNode(type, x, y);
    },

    deleteNodeWithHistory(id) {
      commands.deleteNode(id);
    },

    renameValueNode(nodeId, name) {
      commands.setValueName(nodeId, name);
    },
  };
}
